"use strict";
// A web interface to manage a trail guide mobile app's content and data.
// Copyright (C) 2021-2025  David Lougheed
// See NOTICE for more information.
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var auth0_react_1 = require("@auth0/auth0-react");
var antd_1 = require("antd");
var icons_1 = require("@ant-design/icons");
var hooks_1 = require("../../modules/stations/hooks");
var utils_1 = require("../../utils");
var stationRevisionTitle = (0, utils_1.detailTitle)("Station revisions", "title");
var styles = {
    revisionSelect: { width: "100%" },
};
var StationRevisionView = react_1.default.memo(function () {
    var getAccessTokenSilently = (0, auth0_react_1.useAuth0)().getAccessTokenSilently;
    var navigate = (0, react_router_dom_1.useNavigate)();
    var stationID = (0, react_router_dom_1.useParams)().id;
    var _a = (0, hooks_1.useStations)(), stations = _a.items, stationsInitialFetch = _a.initialFetchDone, stationsFetching = _a.isFetching;
    var station = (0, react_1.useMemo)(function () { return (0, utils_1.findItemByID)(stations, stationID); }, [stations]);
    // ----
    var _b = (0, react_1.useState)(undefined), lhsRevision = _b[0], setLhsRevision = _b[1];
    var _c = (0, react_1.useState)(undefined), rhsRevision = _c[0], setRhsRevision = _c[1];
    var _d = (0, react_1.useState)(null), lhsRevisionData = _d[0], setLhsRevisionData = _d[1];
    var _e = (0, react_1.useState)(null), rhsRevisionData = _e[0], setRhsRevisionData = _e[1];
    var lhsOptions = (0, react_1.useMemo)(function () {
        if (lhsRevision === undefined || rhsRevision === undefined)
            return [];
        if (lhsRevision <= 0 || rhsRevision === 1)
            return [{ value: 0, label: "0" }];
        var n = [];
        for (var i = 1; i < rhsRevision; i++) {
            n.push({ value: i, label: i.toString() });
        }
        return n;
    }, [lhsRevision, rhsRevision]);
    var rhsOptions = (0, react_1.useMemo)(function () {
        var _a;
        if (lhsRevision === undefined || rhsRevision === undefined)
            return [];
        var n = [];
        if (rhsRevision === 1)
            return [{ value: 1, label: "1 (created)" }];
        for (var i = lhsRevision + 1; i <= rhsRevision; i++) {
            n.push({ value: i, label: i === ((_a = station === null || station === void 0 ? void 0 : station.revision) === null || _a === void 0 ? void 0 : _a.number) ? "".concat(i, " (latest)") : i.toString() });
        }
        return n;
    }, [lhsRevision, rhsRevision]);
    (0, react_1.useEffect)(function () {
        var _a;
        if (station && (lhsRevision === undefined || rhsRevision === undefined)) {
            var rhs = (_a = station === null || station === void 0 ? void 0 : station.revision) === null || _a === void 0 ? void 0 : _a.number;
            if (rhs) {
                setLhsRevision(rhs - 1);
                setRhsRevision(rhs);
                setRhsRevisionData(station);
            }
        }
    }, [station]);
    (0, react_1.useEffect)(function () {
        if (!station)
            return;
        if (!lhsRevision)
            return;
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var accessToken, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, getAccessTokenSilently(utils_1.ACCESS_TOKEN_READ)];
                    case 1:
                        accessToken = _b.sent();
                        _a = setLhsRevisionData;
                        return [4 /*yield*/, (0, utils_1.fetchStationRevision)(station.id, lhsRevision, accessToken)];
                    case 2:
                        _a.apply(void 0, [_b.sent()]);
                        return [2 /*return*/];
                }
            });
        }); })();
    }, [lhsRevision]);
    (0, react_1.useEffect)(function () {
        if (!station)
            return;
        if (!rhsRevision)
            return;
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var accessToken, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, getAccessTokenSilently(utils_1.ACCESS_TOKEN_READ)];
                    case 1:
                        accessToken = _b.sent();
                        _a = setRhsRevisionData;
                        return [4 /*yield*/, (0, utils_1.fetchStationRevision)(station.id, rhsRevision, accessToken)];
                    case 2:
                        _a.apply(void 0, [_b.sent()]);
                        return [2 /*return*/];
                }
            });
        }); })();
    }, [rhsRevision]);
    // ----
    var onBack = (0, react_1.useCallback)(function () { return navigate(-1); }, [navigate]);
    var viewStation = (0, react_1.useCallback)(function () { return navigate("/stations/detail/".concat(stationID)); }, [navigate, stationID]);
    var editStation = (0, react_1.useCallback)(function () { return navigate("/stations/edit/".concat(stationID)); }, [navigate, stationID]);
    var onLhsChange = (0, react_1.useCallback)(function (v) { return setLhsRevision(v); }, []);
    var onRhsChange = (0, react_1.useCallback)(function (v) { return setRhsRevision(v); }, []);
    var title = (0, react_1.useMemo)(function () { return stationRevisionTitle(station, stationsInitialFetch, stationsFetching); }, [stationsInitialFetch, stationsFetching, station]);
    var extra = (0, react_1.useMemo)(function () { return [
        react_1.default.createElement(antd_1.Button, { key: "view", icon: react_1.default.createElement(icons_1.EyeOutlined, null), onClick: viewStation }, "View"),
        react_1.default.createElement(antd_1.Button, { key: "edit", icon: react_1.default.createElement(icons_1.EditOutlined, null), onClick: editStation }, "Edit"),
    ]; }, [viewStation, editStation]);
    // noinspection JSValidateTypes
    return react_1.default.createElement(antd_1.PageHeader, { ghost: false, onBack: onBack, title: title, extra: extra },
        react_1.default.createElement(antd_1.Row, { gutter: 16 },
            react_1.default.createElement(antd_1.Col, { span: 12 },
                react_1.default.createElement(antd_1.Select, { options: lhsOptions, value: lhsRevision, style: styles.revisionSelect, onChange: onLhsChange }),
                react_1.default.createElement(antd_1.Divider, null)),
            react_1.default.createElement(antd_1.Col, { span: 12 },
                react_1.default.createElement(antd_1.Select, { options: rhsOptions, value: rhsRevision, style: styles.revisionSelect, onChange: onRhsChange }),
                react_1.default.createElement(antd_1.Divider, null))),
        react_1.default.createElement(antd_1.Row, { gutter: 16 },
            react_1.default.createElement(antd_1.Col, { span: 12 }, lhsRevision > 0
                ? (lhsRevisionData ? react_1.default.createElement("pre", null, JSON.stringify(lhsRevisionData, null, 2)) : react_1.default.createElement("div", null))
                : react_1.default.createElement("span", { style: { fontStyle: "italic", color: "#666" } }, "Not created yet.")),
            react_1.default.createElement(antd_1.Col, { span: 12 }, rhsRevisionData ? react_1.default.createElement("pre", null, JSON.stringify(rhsRevisionData, null, 2)) : react_1.default.createElement("div", null))));
});
exports.default = StationRevisionView;
